// Since Calendly is integrated directly, we just need to track the scheduling
export const updateCalendar = async (meetingDetails) => {
  try {
    const response = await fetch('/api/applications/update-calendar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(meetingDetails),
    });

    if (!response.ok) {
      throw new Error('Failed to update calendar');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating calendar:', error);
    throw error;
  }
}; 